import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

// Fires a page_view to the backend Traffic Monitor on every route change.
export const RouteTracker = () => {
  const loc = useLocation();
  // Capture a refer-a-friend code from ?ref=CODE on ANY landing URL and persist it so it
  // survives navigation and is sent as referral_code on the next registration.
  useEffect(() => {
    try {
      const ref = new URLSearchParams(loc.search).get("ref");
      if (ref) localStorage.setItem("rrc_ref", ref.trim());
    } catch { /* no-op */ }
  }, [loc.search]);
  useEffect(() => {
    const path = loc.pathname;
    const screen = path === "/" ? "home" : path.replace(/^\//, "").split("/")[0];
    api.post("/track", { event: "page_view", screen }).catch(() => {});
  }, [loc.pathname]);
  return null;
};
